import { useEffect, useState } from "react";
import {
  GameClubMyClubBox,
  GameClubMyClubInfo,
  GameClubMyClubInfoBox,
  GameClubMyClubInfoButtonWrapper,
  GameClubMyClubInfoButton,
  GameClubMyClubInfoItem,
  GameClubMyClubWrapper,
} from "../Style/GameClubMyStyles";
import { useGameClubContext } from "../Hook/GameClubContext";
import { ClubTab } from "../Hook/useGameClub";
import { GameClubDto } from "../../../../api/game-club";
import { formatDateToYearMonthDay } from "../../../../utils/date";

interface GameClubMyClubProps {
  data: GameClubDto;
}
export const GameClubMyClub = ({ data }: GameClubMyClubProps) => {
  const [id, setId] = useState<number>(0);
  const [profile, setProfile] = useState<number | null>(null);
  const [clubName, setClubName] = useState<string>("");
  useEffect(() => {
    setId(data.clubId);
    setProfile(data.profileType);
    setClubName(data.name);
  }, [data]);
  const { setIsClubJoin, setPopupType, setGameClubTab, setSelectClubId } =
    useGameClubContext();

  const handleJoin = () => {
    setIsClubJoin(true);
    setPopupType("edit");
    setSelectClubId(id);
  };

  const handleClick = (tab: ClubTab) => {
    setGameClubTab(tab);
  };

  return (
    <>
      <GameClubMyClubWrapper>
        <GameClubMyClubBox>
          <div className="club-profile-background">
            <img
              className="club-profile-background-image"
              src="/image-web/game/club/profile_back.svg"
              alt="프로필 백그라운드"
            />
            {profile !== null && (
              <img
                className="club-profile-image"
                src={`/image-web/game/club/profile_${profile}.png`}
                alt="프로필"
              />
            )}
            {data.isOwner ? (
              <>
                <img
                  onClick={() => {
                    handleJoin();
                  }}
                  className="club-profile-background-image-edit"
                  src="/image-web/game/club/club_profile_edit_btn.png"
                  alt="프로필 백그라운드 수정"
                />
              </>
            ) : (
              ""
            )}
            <div className="club-name">{clubName}</div>
          </div>
        </GameClubMyClubBox>
        <GameClubMyClubInfo>
          <GameClubMyClubInfoBox>
            <GameClubMyClubInfoItem>
              <div className="title">클럽장</div>
              <div className="content">{data.ownerNickname}</div>
            </GameClubMyClubInfoItem>
            <GameClubMyClubInfoItem>
              <div className="title">인원</div>
              <div className="content">{data.memberCount}명</div>
            </GameClubMyClubInfoItem>
            <GameClubMyClubInfoItem>
              <div className="title">랭킹</div>
              <div className="content">{data.clubRank}위</div>
            </GameClubMyClubInfoItem>
            <GameClubMyClubInfoItem>
              <div className="title">클럽개설일</div>
              <div className="content">
                {formatDateToYearMonthDay(data.createdAt)}
              </div>
            </GameClubMyClubInfoItem>
          </GameClubMyClubInfoBox>
          <GameClubMyClubInfoButtonWrapper>
            <GameClubMyClubInfoButton
              onClick={() => {
                handleClick(ClubTab.CHAT);
              }}
            >
              클럽 채팅
            </GameClubMyClubInfoButton>
            <GameClubMyClubInfoButton
              onClick={() => {
                handleClick(ClubTab.MEMBER);
              }}
            >
              클럽원
            </GameClubMyClubInfoButton>
          </GameClubMyClubInfoButtonWrapper>
        </GameClubMyClubInfo>
      </GameClubMyClubWrapper>
    </>
  );
};
